// extracted by mini-css-extract-plugin
export default {"backdrop":"Spinner_backdrop__-393s","loader":"Spinner_loader__f6jiF","skew":"Spinner_skew__pC6ZZ"};